import { connect } from 'react-redux'
import { getNestedProperty } from '@opallabs/lambda'
import { actions, BulkWrapper } from '@opallabs/wormhole'
import AnnotationEditor from '.'

const mapStateToProps = (state, props) => {
  const appState = new BulkWrapper(state)
  let annotations = []
  const currentUser =
    props.currentUser || getNestedProperty(appState, 'user')[0]
  const users = getNestedProperty(appState, 'users')

  if (appState.annotation) {
    annotations = appState.annotation.filter(
      (a) => a.snapshot_id === props.snapshotId
    )
    annotations = annotations.map((a) => ({
      ...a,
      location: JSON.parse(a.location),
    }))
  }

  return { annotations, currentUser, users }
}

const mapDispatchToProps = (dispatch) => ({
  createAnnotation: (options) => dispatch(actions.createAnnotation(options)),
  createMessage: (options) => dispatch(actions.createMessage(options)),
  deleteAnnotation: (options) => dispatch(actions.destroyAnnotation(options)),
  deleteMessage: (options) => dispatch(actions.destroyMessage(options)),
  getAnnotations: (options) => dispatch(actions.getAnnotations(options)),
  getCurrentUser: () => dispatch(actions.getMe()),
})

const ConnectedAnnotationEditor = connect(
  mapStateToProps,
  mapDispatchToProps
)(AnnotationEditor)

export default ConnectedAnnotationEditor
